var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 145,
    viewBox: "0 0 145 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.8486 18.0631C58.8486 20.3258 59.4639 22.4411 60.4594 24.3291C64.3025 23.2622 68.3297 22.6472 72.5043 22.6472C76.6312 22.6472 80.6114 23.2501 84.4166 24.293C85.4 22.4133 86.0096 20.3119 86.0096 18.0626C86.0095 10.6087 79.8874 4.47737 72.4335 4.47754C64.9797 4.47788 58.8487 10.6092 58.8486 18.0631Z",
    fill: "#05164D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5044 27.1963C49.9899 27.1963 31.7231 45.4544 31.7231 67.9688C31.7231 79.7144 31.6699 94.1464 26.1653 108.847H118.87C113.365 94.1464 113.312 79.7144 113.312 67.9688C113.312 45.4544 95.0188 27.1963 72.5044 27.1963Z",
    fill: "#05164D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2096 113.29C19.757 113.29 13.5981 119.422 13.5981 126.875C13.5981 134.327 19.757 140.486 27.2096 140.486H117.826C125.278 140.486 131.402 134.327 131.402 126.875C131.402 119.422 125.278 113.29 117.826 113.29H27.2096Z",
    fill: "#05164D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellNotification);
export default __webpack_public_path__ + "static/media/bellNotification.52bcc24448b1a08a0984ea880e2d66b0.svg";
export { ForwardRef as ReactComponent };